'use client';

import React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import {
  ALGOLIA_INDEX_NAME,
  ALGOLIA_INDEX_LABEL_BY_NAME,
} from 'commons/constants';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../../../commons/helpers';

/**
 * Helper component to get hits count for a specific index
 * This is used within Index widget context
 */
const IndexHitsCount = ({ indexName, toggleSearchOpen }) => {
  const { results } = useInstantSearch();
  const query = results?.query || '';
  const currentPage = useUserCurrentPageType();

  if (!results || !results.nbHits || results.nbHits === 0 || !query) {
    return null;
  }

  const queryWord = query.charAt(0).toUpperCase() + query.slice(1);

  const urlIndexName =
    indexName === ALGOLIA_INDEX_NAME.STATIC_PAGES
      ? 'static_pages_new'
      : indexName;

  const indexLabel = ALGOLIA_INDEX_LABEL_BY_NAME[indexName] ?? indexName;
  const displayName = `${queryWord} in ${indexLabel} (${results.nbHits})`;

  return (
    <Link
      to={getAdvancedSearchUrlForQueryAndIndex(query, urlIndexName)}
      onClick={async () => {
        await toggleSearchOpen();
        avo.productsSearched({
          query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK,
        });
      }}
      className={classNames(
        'text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8',
        {
          'block mr-2.5 text-[#585858]': true,
        }
      )}
    >
      {displayName}
    </Link>
  );
};

IndexHitsCount.propTypes = {
  indexName: PropTypes.string.isRequired,
  toggleSearchOpen: PropTypes.func,
};

export default IndexHitsCount;
